import { Breakpoints, styled } from "@volkswagen-onehub/components-core";
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledAddVehicleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    ${({ theme }: { theme: VWTheme }) => {
        return `
            gap: ${theme.size.static510};
            margin-top: ${theme.size.static350};

            @media (min-width: ${Breakpoints.b560}px) {
                margin-top: ${theme.size.static400};
            }
        `;
    }}
`;

export const StyledAddVehicleSubtitleAndDescription = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }: { theme: VWTheme }) => theme.size.static150};
    align-self: stretch;
`;

export const StyledAddVehicleDescription = styled.div`
    color: ${({ theme }: { theme: VWTheme }) => theme.colors.content.tertiary};
`;

export const StyledAddVehicleAppButtonsContainer = styled.div`
    display: flex;
    gap: ${({ theme }: { theme: VWTheme }) => theme.size.static250};
    align-self: stretch;

    @media(min-width: ${Breakpoints.default}) {
        flex-direction: column;
        align-items: center;
        
        .badge-images {
            height: auto;
            width: 200px;
        }
    }

    @media(min-width: 290px) {
        flex-direction: row;
        align-items: initial;

        .badge-images {
            max-height: none;
            max-width: none;
            height: 100%;
            width: auto;
        }
    }
`;

export const StyledAddVehicleQrCodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: ${({ theme }: { theme: VWTheme }) => theme.size.static250};
`;